/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { WorkDetailBase } from "../../../../schema/generated/WorkDetail";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class WorkDetailDataApi extends EntityDataApi<WorkDetailBase> {
  public readonly def = idbEntityDefs.WorkDetail;
}